import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const CampaignsEmptyState = ({ height = 128, width = 128, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 114 88" {...props}>
    <path
      d="M108.84 51.808C108.84 44.1676 107.129 36.6242 103.834 29.7309C100.539 22.8377 95.7425 16.7693 89.797 11.9706C83.8515 7.17204 76.9074 3.7649 69.4739 1.99904C62.0403 0.233179 54.3058 0.15337 46.8374 1.76546C39.3691 3.37756 32.3561 6.64068 26.3129 11.3156C20.2696 15.9905 15.3492 21.9586 11.9125 28.7824C8.47577 35.6063 6.60981 43.1127 6.45143 50.7515C6.29306 58.3902 7.84628 65.9676 10.9972 72.928H104.284C107.293 66.2941 108.847 59.0926 108.84 51.808Z"
      fill="#F5F4F4"
    />
    <path
      d="M7.08008 72.928H106.92"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.32031 72.928H4.52031"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M109.48 72.928H112.68" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M88.91 84.96C88.91 86.24 74.83 87.392 57.3324 87.392C39.8348 87.392 25.7676 86.304 25.7676 84.96C25.7676 83.616 39.8476 82.528 57.3324 82.528C74.8172 82.528 88.91 83.68 88.91 84.96Z"
      fill="#F5F4F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.334 35.6669H79.6673C84.0856 35.6669 87.6673 39.2486 87.6673 43.6669V65.0002C87.6673 66.473 86.4734 67.6669 85.0006 67.6669H42.334"
      fill="#B56DC6"
    />
    <path
      d="M34.334 35.6669H79.6673C84.0856 35.6669 87.6673 39.2486 87.6673 43.6669V65.0002C87.6673 66.473 86.4734 67.6669 85.0006 67.6669H42.334"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42.334 67.6669H29.0007C27.5279 67.6669 26.334 66.473 26.334 65.0002V43.6669C26.334 39.2486 29.9157 35.6669 34.334 35.6669C38.7523 35.6669 42.334 39.2486 42.334 43.6669V67.6669Z"
      fill="#FDF5FF"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M61.0013 83.6669C61.0011 85.0002 55.6682 85.0002 55.668 83.6669C55.6678 82.3335 55.668 67.6669 55.668 67.6669H61.0013C61.0013 67.6669 61.0015 82.3335 61.0013 83.6669Z"
      fill="#FDF5FF"
      stroke="#6A266D"
    />
    <path
      d="M31.668 62.3338H37.0013"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.668 41L55.668 41L47.668 41Z"
      fill="#E6FBFF"
    />
    <path d="M47.668 41L55.668 41" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M61 41L61 49L55.6667 49L55.6667 41L61 41Z"
      fill="#FDF5FF"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M70.0411 24.706C71.3956 25.5551 72.9446 26.0442 74.5411 26.127C78.8791 26.46 80.5411 25.458 81.1731 24.754C81.2832 24.6331 81.3272 24.4659 81.2909 24.3065C81.2546 24.147 81.1427 24.0154 80.9911 23.954C79.4041 23.1837 77.911 22.2334 76.5411 21.122C76.2041 20.868 75.6681 20.44 75.2021 20.069C75.0663 19.9612 74.996 19.7908 75.0164 19.6186C75.0368 19.4464 75.1449 19.2971 75.3021 19.224C78.6521 17.674 80.8121 14.597 81.4411 10.334C81.4665 10.1619 81.4007 9.98897 81.2672 9.87737C81.1338 9.76577 80.952 9.73154 80.7871 9.78698C79.0621 10.365 74.9331 11.86 74.5381 13.043C74.1671 14.157 73.2441 16.343 72.7931 17.401C72.7323 17.5426 72.6095 17.6483 72.4604 17.6873C72.3113 17.7264 72.1526 17.6946 72.0301 17.601C70.7334 16.4541 69.1996 15.6077 67.5381 15.122C66.6811 14.9017 65.7704 15.0994 65.0819 15.6553C64.3935 16.2112 64.0083 17.0598 64.0431 17.944C64.0363 18.055 63.9926 18.1606 63.9191 18.244C63.5953 18.5882 63.4145 19.0425 63.4131 19.515C63.4124 19.6709 63.4845 19.8182 63.6081 19.9134C63.7316 20.0085 63.8925 20.0405 64.0431 20L65.5431 19.625"
      fill="#FDF5FF"
    />
    <path
      d="M70.0411 24.706C71.3956 25.5551 72.9446 26.0442 74.5411 26.127C78.8791 26.46 80.5411 25.458 81.1731 24.754C81.2832 24.6331 81.3272 24.4659 81.2909 24.3065C81.2546 24.147 81.1427 24.0154 80.9911 23.954C79.4041 23.1837 77.911 22.2334 76.5411 21.122C76.2041 20.868 75.6681 20.44 75.2021 20.069C75.0663 19.9612 74.996 19.7908 75.0164 19.6186C75.0368 19.4464 75.1449 19.2971 75.3021 19.224C78.6521 17.674 80.8121 14.597 81.4411 10.334C81.4665 10.1619 81.4007 9.98897 81.2672 9.87737C81.1338 9.76577 80.952 9.73154 80.7871 9.78698C79.0621 10.365 74.9331 11.86 74.5381 13.043C74.1671 14.157 73.2441 16.343 72.7931 17.401C72.7323 17.5426 72.6095 17.6483 72.4604 17.6873C72.3113 17.7264 72.1526 17.6946 72.0301 17.601C70.7334 16.4541 69.1996 15.6077 67.5381 15.122C66.6811 14.9017 65.7704 15.0994 65.0819 15.6553C64.3935 16.2112 64.0083 17.0598 64.0431 17.944C64.0363 18.055 63.9926 18.1606 63.9191 18.244C63.5953 18.5881 63.4145 19.0425 63.4131 19.515C63.4124 19.6709 63.4845 19.8182 63.6081 19.9134C63.7316 20.0085 63.8925 20.0405 64.0431 20L65.5431 19.625L70.0411 24.706Z"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M66.7998 17.127C66.9379 17.127 67.0498 17.2389 67.0498 17.377C67.0498 17.5151 66.9379 17.627 66.7998 17.627C66.6617 17.627 66.5498 17.5151 66.5498 17.377C66.5495 17.3106 66.5758 17.2469 66.6227 17.1999C66.6697 17.153 66.7334 17.1267 66.7998 17.127"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M70.4395 16.3723C70.4395 16.3723 69.9395 12.3723 69.9395 10.3723C69.9395 9.24431 71.9185 6.98631 72.9005 5.93431C73.0199 5.80658 73.1974 5.75054 73.3685 5.78653C73.5397 5.82251 73.6796 5.94529 73.7375 6.11031C74.2062 7.48215 74.8989 10.8744 74.8936 12.3242"
      fill="#FDF5FF"
    />
    <path
      d="M70.4395 16.3723C70.4395 16.3723 69.9395 12.3723 69.9395 10.3723C69.9395 9.24431 71.9185 6.98631 72.9005 5.93431C73.0199 5.80658 73.1974 5.75054 73.3685 5.78653C73.5397 5.82251 73.6796 5.94529 73.7375 6.11031C74.2062 7.48215 74.8989 10.8744 74.8936 12.3242L72.5 17.4999L70.4395 16.3723Z"
      fill="#FDF5FF"
    />
    <path
      d="M70.4395 16.3723C70.4395 16.3723 69.9395 12.3723 69.9395 10.3723C69.9395 9.24431 71.9185 6.98631 72.9005 5.93431C73.0199 5.80658 73.1974 5.75054 73.3685 5.78653C73.5397 5.82251 73.6796 5.94529 73.7375 6.11031C74.2062 7.48215 74.8989 10.8744 74.8936 12.3242L72.5 17.4999L70.4395 16.3723Z"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M75.3086 26.193L76.5456 28.048"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M78.2148 26.051L79.5458 28.048"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M67.0459 20.6269L69.5459 21.1269L67.0459 26.6269L58.5459 24.6269L61.0459 19.1269L63.4709 19.7329"
      fill="#E6FBFF"
    />
    <path
      d="M67.0459 20.6269L69.5459 21.1269L67.0459 26.6269L58.5459 24.6269L61.0459 19.1269L63.4709 19.7329L67.0459 20.6269Z"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M61.0459 19.1269L63.5459 23.1269L69.5459 21.1269"
      fill="#E6FBFF"
    />
    <path
      d="M61.0459 19.1269L63.5459 23.1269L69.5459 21.1269"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
